class Token {
  protected token: string
  protected refresh_token: string
  protected expires_in: number
  protected scope: string
  protected token_type: string
  protected created_time: number

  constructor(
    token: string,
    refresh_token: string,
    scope: string,
    token_type: string,
    expires_in: number
  ) {
    this.token = token
    this.refresh_token = refresh_token
    this.scope = scope
    this.token_type = token_type
    this.expires_in = expires_in
    this.created_time = new Date().getTime()
  }

  getToken() {
    return this.token
  }

  getRefreshToken() {
    return this.refresh_token
  }

  getScope() {
    return this.scope
  }

  getTokenType() {
    return this.token_type
  }

  getExpiresIn() {
    return this.expires_in
  }

  getCreatedTime() {
    return this.created_time
  }

  getExpirationTime() {
    const created = this.created_time
    const durationTime = this.expires_in * 1000
    const expiresTime = created + durationTime
    return expiresTime
  }

  isExpired() {
    const now = new Date().getTime()
    const expirationTime = this.getExpirationTime()
    if (now > expirationTime) {
      // console.log('expiro')
    } else {
      // console.log('no expiro')
    }
  }
}

export default Token
